import { pgEnum } from 'drizzle-orm/pg-core';

// Tipologia de aplicações usada pela Masterboi (data.jsx · APP_TYPES).
export const appTypeEnum = pgEnum('app_type', [
  'power-apps',
  'fullstack',
  'web',
  'mobile',
  'integracao',
  'rpa',
  'api',
  'data',
  'infra',
]);

// Visibilidade — controla quem vê a app (data.jsx · VisibilityBadge).
export const visibilityEnum = pgEnum('visibility', ['publico', 'privado', 'interno']);

/**
 * Estado da aplicação (data.jsx · STATUS_TYPES).
 *
 * `pausado` é o projeto INICIADO e PARADO por decisão — ficou em espera e pode
 * voltar. Existe como situação própria porque as outras quatro mentiriam a
 * respeito dele: `dev` afirmaria que alguém está construindo (não está),
 * `manutencao` afirmaria que está no ar recebendo correção (não está no ar) e
 * `depreciado` afirmaria que foi descontinuado (não foi — a retomada continua
 * na mesa). Sem ele, projeto parado some do radar disfarçado de projeto em
 * andamento, e é justamente o que a diretoria precisa enxergar no deck.
 *
 * A POSIÇÃO no enum do Postgres é só a ordem de criação (`ADD VALUE` no fim);
 * a ordem de exibição é outra coisa e vive em `DECK_STATUS_ORDER` (deck) e
 * `CATALOG_VIEWS` (catálogo).
 */
export const appStatusEnum = pgEnum('app_status', [
  'prod',
  'homolog',
  'dev',
  'depreciado',
  'manutencao',
  'pausado',
]);

// Criticidade (data.jsx · CriticalityBadge).
export const criticalityEnum = pgEnum('criticality', ['alta', 'media', 'baixa']);

// Usuário — role + status de acesso (espelho do Clerk).
export const userRoleEnum = pgEnum('user_role', ['admin', 'user']);

/**
 * Status de acesso da conta.
 *
 *  - `approved`  — acesso liberado (o normal; toda conta nasce assim);
 *  - `pending` / `rejected` — marcação MANUAL no banco, sem tela nem endpoint
 *    (`rejected` revoga sem apagar histórico);
 *  - `inactive`  — DESATIVADA PELO RH, automaticamente. Entrou para a regra de
 *    demissão: matrícula com `CODSITUACAO = 'D'` no TOTVS perde o acesso sozinha,
 *    sem ninguém precisar lembrar de revogar. É estado distinto de `rejected` de
 *    propósito — um é decisão de pessoa, o outro é consequência do RH, e a tela
 *    de usuários precisa dizer qual dos dois aconteceu.
 *
 * `inactive` não exige nada do middleware: `blockUnapproved` já barra tudo que
 * não é `approved`. O que ele ganha é mensagem própria (ver `middleware/auth.ts`),
 * senão o demitido leria "sua conta foi rejeitada".
 */
export const userStatusEnum = pgEnum('user_status', [
  'pending',
  'approved',
  'rejected',
  'inactive',
]);
